import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UtilService } from "./util.service";
import { StaticDataService } from "./static-data.service";
import { Observable, Subject, of } from "rxjs";
import { catchError, take, tap, map, switchMap } from "rxjs/operators";
import * as _ from "lodash";
import { Injectable, Injector } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

const BackendUrl = environment.BackendUrl;

@Injectable({
  providedIn: "root",
})
export class OrganisationService {
  departmentChanged = new Subject<any>();
  organisationChanged = new Subject<any>();
  getOrganisationDataUpdated = new Subject<any>();
  getOrganisationDataDocumentUpdated = new Subject<any>();
  getOrganisationDataVideoUpdated = new Subject<any>();
  getOrganisationNavDataUpdated = new Subject<any>();
  getOrganisationSubDataUpdated = new Subject<any>();
  getOrganisationNewsDataUpdated = new Subject<any>();
  getOrganisationOrgDataUpdated = new Subject<any>();
  getOrganisationAllDepartmentNamesDataUpdated = new Subject<any>();
  getOrganisationsHistoryUpdated = new Subject<any>();
  getOrganisationDataUpdatedDepartmentFiles = new Subject<any>();
  getOrganisationLinksDataUpdated = new Subject<any>();
  getOrganisationLinksDepartmentDataUpdated = new Subject<any>();
  getCompanyInfoDataUpdated = new Subject<any>();
  setProductList = new Subject<any>();
  setCoordinatorList = new Subject<any>();
  setRiskAssessmentActivityList  = new Subject<any>();
  setRiskAssessmentList = new Subject<any>();
  setCatalogueList = new Subject<any>();
  setSubstitutionList = new Subject<any>();

  constructor(
    private http: HttpClient,
    private utilService: UtilService,
    private staticDataService: StaticDataService
  ) {}

  getAllcDocFiles() {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/cdoc/cdoc_files/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (documents) => {
          this.getOrganisationDataDocumentUpdated.next(documents);
        },
        error: (error) => {
          this.getOrganisationDataDocumentUpdated.next(null);
        },
      });
  }

  getcDocFileWithId(fileId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get(BackendUrl + "/organisations/cdoc/cdoc_files/" + fileId, {
        headers: headers,
        responseType: "arraybuffer",
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          var file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          this.getOrganisationDataUpdated.next(fileURL);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  deletecDocFileWithId(fileId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete(BackendUrl + "/organisations/cdoc/cdoc_files/" + fileId + "/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  addcDocFile(fileInfo) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + "/organisations/cdoc/cdoc_files/", fileInfo, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getAllcDocVideos() {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/cdoc/cdoc_videos/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (videos) => {
          this.getOrganisationDataVideoUpdated.next(videos);
        },
        error: () => {
          this.getOrganisationDataVideoUpdated.next(null);
        },
      });
  }

  addcDocVideo(videoInfo: { title: string; videoid: string; language: number }) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + "/organisations/cdoc/cdoc_videos/", videoInfo, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: () => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  deletecDocVideoWithId(videoId: string | number) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete(BackendUrl + "/organisations/cdoc/cdoc_videos/" + videoId + "/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: () => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  addEachFile(object) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + "/organisations/addEachFile/", object, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getOrganisation(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get(BackendUrl + "/organisations/" + orgId + "/tree", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationOrgDataUpdated.next(response[0]);
        },
        error: (error) => {
          this.getOrganisationOrgDataUpdated.next(null);
        },
      });
  }

  getAllDepartmentNames(mainOrganisation) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    if (mainOrganisation) {
      var params = new HttpParams().set("mainOrganisation", mainOrganisation);

      this.http
        .get<any>(
          BackendUrl +
            "/organisations/" +
            mainOrganisation.id +
            "/getAllDepartmentNames",
          { headers: headers, params: params, responseType: "json" }
        )

        .pipe(take(1)).subscribe({
          next: (response) => {
            this.getOrganisationAllDepartmentNamesDataUpdated.next(response);
          },
          error: (error) => {
            this.getOrganisationAllDepartmentNamesDataUpdated.next(null);
          },
        });
      }
  }

  getAllNews() {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/cdoc/cdoc_news/", {
        headers: headers,
      })

      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationNewsDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationNewsDataUpdated.next(null);
        },
      });
  }

  addNews(newsitem) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .post<any>(BackendUrl + "/organisations/cdoc/cdoc_news/",newsitem, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationNewsDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationNewsDataUpdated.next(null);
        },
      });
  }

  deleteNews(Id) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .delete<any>(BackendUrl + "/organisations/cdoc/cdoc_news/"+Id, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationNewsDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationNewsDataUpdated.next(null);
        },
      });
  }

  SingleWithSuborganisation(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId + "/tree", {
        headers: headers,
      })

      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  /**
   * Fetch organisations (companies). Optional filter for subscription (organisation table / organisations_subscriptions).
   * Backend can support: subscription_identifier, type_of_subscription, group_id.
   * Returns the HTTP Observable so callers are not raced by getAllCompanyNames() on the shared Subject.
   */
  getAllCompanies(filter?: {
    subscription_identifier?: string;
    type_of_subscription?: string;
    group_id?: string;
  }): Observable<any> {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    let params = new HttpParams();
    if (filter?.subscription_identifier) {
      params = params.set("subscription_identifier", filter.subscription_identifier);
    }
    if (filter?.type_of_subscription) {
      params = params.set("type_of_subscription", filter.type_of_subscription);
    }
    if (filter?.group_id) {
      params = params.set("group_id", filter.group_id);
    }

    const options = params.keys().length ? { headers, params } : { headers };

    return this.http.get<any>(BackendUrl + "/organisations/companies", options).pipe(
      take(1),
      tap({
        next: (response) => this.getOrganisationNavDataUpdated.next(response),
        error: () => this.getOrganisationNavDataUpdated.next(null),
      }),
      catchError(() => of(null))
    );
  }

  /** Organisation groups (koncern). */
  getOrganisationGroups(): Observable<any> {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    return this.http.get<any>(BackendUrl + "/organisation-groups", { headers }).pipe(
      take(1),
      catchError(() => of(null))
    );
  }

  getOrganisationGroup(id: string): Observable<any> {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    return this.http.get<any>(BackendUrl + "/organisation-groups/" + id, { headers }).pipe(
      take(1),
      catchError(() => of(null))
    );
  }

  createOrganisationGroup(group: { name: string; active?: number | boolean }): Observable<any> {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    return this.http.post<any>(BackendUrl + "/organisation-groups", group, { headers }).pipe(
      take(1),
      catchError(() => of(null))
    );
  }

  updateOrganisationGroup(id: string, group: { name?: string; active?: number | boolean }): Observable<any> {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    return this.http.put<any>(BackendUrl + "/organisation-groups/" + id, group, { headers }).pipe(
      take(1),
      catchError(() => of(null))
    );
  }

  /** Assign or clear a company's koncern (group_id) via full organisation get+put. */
  setOrganisationGroupId(organisationId: string, groupId: string | null): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    return this.http.get<any>(BackendUrl + "/organisations/" + organisationId, { headers }).pipe(
      take(1),
      map((response) => this.subscriptionIdentifiersToObjects(response)),
      switchMap((org) => {
        if (!org) {
          return of(null);
        }
        const payload = { ...org, group_id: groupId };
        this.subscriptionObjectsToIdentifiers(payload, false);
        return this.http.put<any>(BackendUrl + "/organisations/" + organisationId, payload, { headers });
      }),
      catchError(() => of(null))
    );
  }

  /**
   * Fetch organisations (companies). Optional filter for subscription (organisation table / organisations_subscriptions).
   * Backend can support: subscription_identifier, type_of_subscription.
   */
  getAllCompanyNames() {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/companynames", { headers: headers })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationNavDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationNavDataUpdated.next(null);
        },
      });
  }

  /**
   * Fetch subscription info per organisation. Optional filter by subscription_identifier
   * so backend can filter on organisations_subscriptions.
   */
  getAllSubscriptionInfo(filter?: { subscription_identifier?: string }): Observable<any> {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    let params = new HttpParams();
    if (filter?.subscription_identifier) {
      params = params.set("subscription_identifier", filter.subscription_identifier);
    }

    const options = params.keys().length ? { headers, params } : { headers };

    return this.http.get<any>(BackendUrl + "/organisations/subscriptioninfo", options).pipe(
      take(1),
      tap({
        next: (response) => this.getOrganisationSubDataUpdated.next(response),
        error: () => this.getOrganisationSubDataUpdated.next(null),
      }),
      catchError(() => of(null))
    );
  }

  // So that the organisationtree isnt abused
  getAllCompanies2() {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/companies", { headers: headers })

      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getNewFreemiumCompanies() {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.get<any>(BackendUrl + '/frm/register/list', {headers: headers})

    .pipe(take(1)).subscribe({next: response => {
        this.getOrganisationDataUpdated.next(response);
      },
      error: error => {
        this.getOrganisationDataUpdated.next(null);
      }
    });
  }

  getAllFreemiumCompanies() {
    let token = localStorage.getItem('token');

    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});

    this.http.get<any>(BackendUrl + "/organisations/freemiumcompanies", {headers: headers})

    .pipe(take(1)).subscribe({next: response2 => {
        this.getOrganisationDataUpdated.next(response2);
      },
      error: error => {
        this.getOrganisationDataUpdated.next(null);
      }
    });
  }

  addFreemiumUser(userInfo) {
    let token = localStorage.getItem("token");
    if(!token){
      token = "123456"; // This is just something I use so that it isn't null,
                        // the backend  call doesnt send if it is null.
                        // Since this action is done before user is logged in the
                        // token is probably null the token isn't used backend.
    }

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + '/frm/register', userInfo, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getThisOrganisation() {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations", { headers: headers })

      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getSingleOrganisation(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId, { headers: headers })

      .pipe(take(1)).subscribe({
        next: (response) => {
          response = this.subscriptionIdentifiersToObjects(response);
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getSingleCompanyInfo(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId, { headers: headers })

      .pipe(take(1)).subscribe({
        next: (response) => {
          response = this.subscriptionIdentifiersToObjects(response);
          this.getCompanyInfoDataUpdated.next(response);
        },
        error: (error) => {
          this.getCompanyInfoDataUpdated.next(null);
        },
      });
  }

  ParentSubOrganisation(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId + "/parent", {
        headers: headers,
      })

      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  createNewDepartment(orgId, object, partentId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    var info = {
      name: object.name||'',
      misc: object.misc||'',
      address_visit: object.address_visit||'',
      parent_id: partentId,
    };

    this.http
      .post<any>(BackendUrl + "/organisations", info, { headers: headers })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  removeDepartment(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete<any>(BackendUrl + "/organisations/" + orgId, { headers: headers })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(true);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(true);
        },
      });
  }

  updateDepartment(departmentId, department) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .put<any>(
        BackendUrl + "/organisations/" + departmentId + "/update",
        department,
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(true);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getAllFiles(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId + "/files/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getAllLinks(orgId) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId + "/links/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationLinksDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationLinksDataUpdated.next(null);
        },
      });
  }

  getAllLinksDepartment(orgId) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId + "/linksdepartment/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationLinksDepartmentDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationLinksDepartmentDataUpdated.next(null);
        },
      });
  }

  getAllFilesDepartments(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get<any>(BackendUrl + "/organisations/" + orgId + "/files/", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdatedDepartmentFiles.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdatedDepartmentFiles.next(null);
        },
      });
  }

  getFileWithId(orgId, file_id, fileExtension?: string) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    const mimeTypes: Record<string, string> = {
      pdf: "application/pdf",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      xls: "application/vnd.ms-excel",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ppt: "application/vnd.ms-powerpoint",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      gif: "image/gif",
      webp: "image/webp",
    };
    const ext = (fileExtension ?? "").trim().toLowerCase().replace(/^\./, "");
    const mimeType = mimeTypes[ext] || "application/octet-stream";

    this.http
      .get(BackendUrl + "/organisations/" + orgId + "/files/" + file_id, {
        headers: headers,
        responseType: "arraybuffer",
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          var file = new Blob([response], { type: mimeType });
          var fileURL = URL.createObjectURL(file);
          this.getOrganisationDataUpdated.next(fileURL);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  deleteFileWithId(orgId, file_id) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete(
        BackendUrl + "/organisations/" + orgId + "/files/" + file_id + "/",
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  deleteLinkWithId(orgId, link_id) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete(
        BackendUrl + "/organisations/" + orgId + "/links/" + link_id + "/",
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationLinksDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationLinksDataUpdated.next(null);
        },
      });
  }

  deleteLinkDepartmentWithId(orgId, link_id) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete(
        BackendUrl + "/organisations/" + orgId + "/linksdepartment/" + link_id + "/",
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationLinksDepartmentDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationLinksDepartmentDataUpdated.next(null);
        },
      });
  }

  SingleUpdateCompanyInformation(orgId, organisation) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .put<any>(
        BackendUrl + "/organisations/" + orgId + "/update",
        organisation,
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(true);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  SingleUpdateCompanyInformationMisc ( orgId, organisation ) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .put<any>(
        BackendUrl + "/organisations/" + orgId + "/updatemisc",
        organisation,
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(true);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  makeOrganisationTreeChanges(department) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .put<any>(
        BackendUrl + "/organisations/" + department.id,
        { parent_id: department.parent },
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(true);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  addFile(orgId, fileInfo) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + "/organisations/" + orgId + "/files", fileInfo, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  addLink ( orgId, text) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + "/organisations/" + orgId + "/links", text, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationLinksDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationLinksDataUpdated.next(null);
        },
      });
  }

  addLinkDepartment ( orgId, text) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + "/organisations/" + orgId + "/linksdepartment", text, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationLinksDepartmentDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationLinksDepartmentDataUpdated.next(null);
        },
      });
  }

  removeProductArticleNumber(orgId, article) {
    var articleToRemove = this.utilService.serialize(article);

    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(
        BackendUrl + "/organisations/" + orgId + "/articleNumbersProducts",
        articleToRemove,
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  saveProductArticleNumbers(orgId, article) {
    var articlesToBeSaved = this.utilService.serialize(article);

    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .put<any>(
        BackendUrl + "/organisations/" + orgId + "/articlenumbersProducts",
        articlesToBeSaved,
        { headers: headers }
      )
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getProductArticleNumbers(orgId) {
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get(BackendUrl + "/organisations/" + orgId + "/articlenumbersProducts", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getParentFromDepartment(department) {
    var parent = "";
    if (department) {
      parent = department.parent;
      this.ParentSubOrganisation(parent);
      this.getOrganisationDataListener()
        .pipe(take(1))
        .subscribe({
          next: (parentorg) => {
            if (parentorg != null) {
              if (parentorg.id === "123") {
                parentorg.name = "";
              }
              localStorage.setItem("selectedParent", parentorg);
            } else {
            }
          },
          error: (error) => {},
        });
    }
  }

  changeDepartmentById(departmentId) {
    this.getOrganisation(departmentId);
    this.getOrganisationOrgDataListener().pipe(take(1))
      .subscribe({next: (department) => {
          if (department != null) {

            localStorage.setItem('selectedDepartment', JSON.stringify(department));
            var selectedDepartment = JSON.parse(
              localStorage.getItem("selectedDepartment")
            );

            var rootOrganisation = JSON.parse(
              localStorage.getItem("rootOrganisation")
            );

            if (!rootOrganisation) {
              rootOrganisation = department;
            }

            if (selectedDepartment.main_organisation != rootOrganisation.id) {
              this.getSingleOrganisation(selectedDepartment.main_organisation);
              this.getOrganisationDataListener().pipe(take(1))
                .subscribe({
                  next: (department) => {
                    if (department != null) {
                      localStorage.setItem('selectedOrganisation', JSON.stringify(selectedDepartment));
                      localStorage.setItem('rootOrganisation', JSON.stringify(selectedDepartment));
                      this.departmentChanged.next(selectedDepartment);
                    } else {
                    }
                  },
                  error: (error) => {},
                });
            } else {
              this.departmentChanged.next(department);
            }
          }
        },
        error: (error) => {},
      });
  }

  changeDepartment(departmentId) {
    this.getOrganisation(departmentId);
    this.getOrganisationOrgDataListener().pipe(take(1))
      .subscribe({next: (department) => {
          if (department != null) {

            localStorage.setItem('selectedDepartment', JSON.stringify(department));
            var selectedDepartment = JSON.parse(
              localStorage.getItem("selectedDepartment")
            );

            var rootOrganisation = JSON.parse(
              localStorage.getItem("rootOrganisation")
            );

            if (!rootOrganisation) {
              rootOrganisation = department;
            }

            if (selectedDepartment.main_organisation != rootOrganisation.id) {
              this.getSingleOrganisation(selectedDepartment.main_organisation);
              this.getOrganisationDataListener().pipe(take(1))
                .subscribe({
                  next: (department) => {
                    if (department != null) {
                      localStorage.setItem('selectedOrganisation', JSON.stringify(selectedDepartment));
                      localStorage.setItem('rootOrganisation', JSON.stringify(selectedDepartment));
                    } else {
                    }
                  },
                  error: (error) => {},
                });
            } else {
            }
          }
        },
        error: (error) => {},
      });
  }


  getSecretChem() {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .get<any>(BackendUrl + "/organisations/getsecretchem", {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  idExistsInProducts(id){
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .get(BackendUrl + "/organisations/idexists/" + id, {
        headers: headers
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          if(!response||response==null){
            this.getOrganisationDataUpdated.next(false);
          } else {
            this.getOrganisationDataUpdated.next(response);
          }
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(false);
        },
      });

  }

  createSingle(object) {
    var organisation = this.utilService.serialize(object);
    this.subscriptionObjectsToIdentifiers(organisation, true);
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .post<any>(BackendUrl + "/organisations", organisation, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  updateSingle(id, object) {
    // var organisation = this.utilService.serialize(object);
    this.subscriptionObjectsToIdentifiers(object, false);
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .put<any>(BackendUrl + "/organisations/" + id, object, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  updateFrmUser(id, object) {
    var organisation = this.utilService.serialize(object);
    this.subscriptionObjectsToIdentifiers(organisation, false);
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .put<any>(BackendUrl + "/frm/register/" + id, organisation, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  removeSingle(id) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });
    this.http
      .delete<any>(BackendUrl + "/organisations/" + id, { headers: headers })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  addSubstitution(object) {

    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    // Since I need body.object backend and not body, something that is changed from angular versions
    var params = new HttpParams().set("object", object);
    this.http.post<any>(BackendUrl + "/organisations/newsubstitution", object, {headers: headers, params:params})
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
    });
  }

  // Needed functions for subscriptions
  subscriptionIdentifiersToObjects(organisation) {
    var subscription;

    if (_.isObject(organisation)) {
      organisation.subscriptions = [];

      if (organisation.subscription_activities) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_activities"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_app) {
        subscription =
          this.staticDataService.getSubscriptionByIdentifier(
            "subscription_app"
          );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_catalogue) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_catalogue"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_classification) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_classification"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_coordinator) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_coordinator"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_distribution) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_distribution"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_exposures) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_exposures"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_grb) {
        subscription =
          this.staticDataService.getSubscriptionByIdentifier(
            "subscription_grb"
          );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_lawpoint) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_lawpoint"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_law_aptor) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_law_aptor"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_products) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_products"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_product_analysis) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_product_analysis"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_productsheet) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_productsheet"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_projects) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_projects"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_purchase) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_purchase"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_reports) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_reports"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_classification) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_classification"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_cmr) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_cmr"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_fire) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_fire"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_grb) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_grb"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_notes) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_notes"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_sds) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_sds"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_simple) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_simple"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_statutory) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_statutory"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_sds) {
        subscription =
          this.staticDataService.getSubscriptionByIdentifier(
            "subscription_sds"
          );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_checklist) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_checklist"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_enviroment) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_enviroment"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_purchase) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_purchase"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_sds_activity) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_sds_activity"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_transport) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_transport"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_special_demands) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_special_demands"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_sll) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_sll"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_labels) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_labels"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_freemium) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_freemium"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_risk_assessment) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_risk_assessment"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_substitution) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_substitution"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_product_application) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_product_application"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_samtec) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_samtec"
        );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_revise_date) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_revise_date"
        );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_qrcode) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_qrcode"
        );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_secret_chemical) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_secret_chemical"
        );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_stamped_SDS) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_stamped_SDS"
        );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_sin) {
        subscription =
          this.staticDataService.getSubscriptionByIdentifier(
            "subscription_sin"
          );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_sll) {
        subscription =
          this.staticDataService.getSubscriptionByIdentifier(
            "subscription_sll"
          );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_basta) {
        subscription =
          this.staticDataService.getSubscriptionByIdentifier(
            "subscription_basta"
          );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_report_allergenic) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_allergenic"
        );
        organisation.subscriptions.push(subscription);
      }
      if (organisation.subscription_education) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_education"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_mail_sds) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_mail_sds"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_styren) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_styren"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_list_pop) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_list_pop"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_list_rohs) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_list_rohs"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_list_prop65) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_list_prop65"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_QRLogin) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
            "subscription_QRLogin"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_inventory) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_inventory"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_ai) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_ai"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_subjectgroups) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_subjectgroups"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_report_substances) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_report_substances"
        );
        organisation.subscriptions.push(subscription);
      }

      if (organisation.subscription_food_approved) {
        subscription = this.staticDataService.getSubscriptionByIdentifier(
          "subscription_food_approved"
        );
        organisation.subscriptions.push(subscription);
      }
    }

    return organisation;
  }

  setTransportInfo(object) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.post<any>(BackendUrl + '/organisations/setTransportInfo', object, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {
        this.getOrganisationDataUpdated.next(response);
      },
      error: error => {
        this.getOrganisationDataUpdated.next(null);
      }
    });
  }

  removeTransportInfo(object) {
    let token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Accept':'application/json','Authorization':token});
    this.http.post<any>(BackendUrl + '/organisations/removeTransportInfo', object, {headers: headers})
      .pipe(take(1)).subscribe({next: response => {
        this.getOrganisationDataUpdated.next(response);
      },
      error: error => {
        this.getOrganisationDataUpdated.next(null);
      }
    });
  }

  subscriptionIdentifiersToObjectsArray(organisations) {
    var i;

    if (_.isArray(organisations)) {
        for (i = 0; i < organisations.length; i += 1) {
            this.subscriptionIdentifiersToObjects(organisations[i]);
        }
    }

    return organisations;
}

  subscriptionObjectsToIdentifiers(organisation, isNew) {
    var i;

    organisation.subscription_activities = 0;
    organisation.subscription_app = 0;
    organisation.subscription_catalogue = 0;
    organisation.subscription_classification = 0;
    organisation.subscription_coordinator = 0;
    organisation.subscription_distribution = 0;
    organisation.subscription_exposures = 0;
    organisation.subscription_grb = 0;
    organisation.subscription_lawpoint = 0;
    organisation.subscription_law_aptor = 0;
    organisation.subscription_products = 0;
    organisation.subscription_product_analysis = 0;
    organisation.subscription_productsheet = 0;
    organisation.subscription_projects = 0;
    organisation.subscription_purchase = 0;
    organisation.subscription_reports = 0;
    organisation.subscription_report_classification = 0;
    organisation.subscription_report_cmr = 0;
    organisation.subscription_report_fire = 0;
    organisation.subscription_report_grb = 0;
    organisation.subscription_report_notes = 0;
    organisation.subscription_report_sds = 0;
    organisation.subscription_report_simple = 0;
    organisation.subscription_report_statutory = 0;
    organisation.subscription_sds = 0;
    organisation.subscription_report_enviroment = 0;
    organisation.subscription_checklist = 0;
    organisation.subscription_report_purchase = 0;
    organisation.subscription_report_sds_activity = 0;
    organisation.subscription_transport = 0;
    organisation.subscription_special_demands = 0;
    organisation.subscription_report_sll = 0;
    organisation.subscription_labels = 0;
    organisation.subscription_freemium = 0;
    organisation.subscription_risk_assessment = 0;
    organisation.subscription_substitution = 0;
    organisation.subscription_samtec = 0;
    organisation.subscription_revise_date = 0;
    organisation.subscription_qrcode = 0;
    organisation.subscription_secret_chemical = 0;
    organisation.subscription_stamped_SDS = 0;
    organisation.subscription_sin = 0;
    organisation.subscription_sll = 0;
    organisation.subscription_basta = 0;
    organisation.subscription_report_allergenic = 0;
    organisation.subscription_education = 0;
    organisation.subscription_mail_sds = 0;
    organisation.subscription_styren = 0;
    organisation.subscription_product_application = 0;
    organisation.subscription_list_pop = 0;
    organisation.subscription_list_rohs = 0;
    organisation.subscription_list_prop65 = 0;
    organisation.subscription_QRLogin = 0;
    organisation.subscription_inventory = 0;
    organisation.subscription_ai = 0;
    organisation.subscription_report_subjectgroups = 0;
    organisation.subscription_report_substances = 0;
    organisation.subscription_food_approved = 0;

    if (organisation.subscriptions && _.isArray(organisation.subscriptions)) {
      for (i = 0; i < organisation.subscriptions.length; i += 1) {
        if (organisation.subscriptions[i].active && isNew) {
          organisation[organisation.subscriptions[i].identifier] = 1;
        } else {
          organisation[organisation.subscriptions[i].identifier] = 1;
        }
      }
    }
    delete organisation.subscriptions;
    return organisation;
  }

  uploadProductArticleNumberFile(object){
    let token = localStorage.getItem("token");

    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .post<any>(BackendUrl + "/organisations/uploadProductArticleNumberFile/", object, {
        headers: headers,
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  getArticleNumberFile(file_id, file_type) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

      // Map filetype to MIME type
    const mimeTypes = {
    pdf: "application/pdf",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xls: "application/vnd.ms-excel",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "": "application/octet-stream", // Default for unknown file types
  };

  const mimeType = mimeTypes[file_type] || "application/octet-stream";
    this.http
      .get(BackendUrl + "/organisations/productArticleNumberGetFile/" + file_id, {
        headers: headers,
        responseType: "arraybuffer"
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          var file = new Blob([response], { type: mimeType });
          var fileURL = URL.createObjectURL(file);
          this.getOrganisationDataUpdated.next(fileURL);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }

  deleteArticleNumberFile(object) {
    let token = localStorage.getItem("token");
    const headers = new HttpHeaders({
      Accept: "application/json",
      Authorization: token,
    });

    this.http
      .delete(BackendUrl + "/organisations/deleteArticleNumberFile/" + object.customerarticle_file_id, {
        headers: headers,
        body: object
      })
      .pipe(take(1)).subscribe({
        next: (response) => {
          this.getOrganisationDataUpdated.next(response);
        },
        error: (error) => {
          this.getOrganisationDataUpdated.next(null);
        },
      });
  }



  getOrganisationsHistory(rootOrganisationId: string | number) {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: token,
    });

    this.http
      .get<any>(`${BackendUrl}/organisations/history/${rootOrganisationId}`, { headers })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const rows = Array.isArray(response) ? response : [];
          this.getOrganisationsHistoryUpdated.next(rows);
        },
        error: () => {
          this.getOrganisationsHistoryUpdated.next([]);
        },
      });
  }

  public getOrganisationsHistoryListener() {
    return this.getOrganisationsHistoryUpdated.asObservable();
  }

  // $resource(BackendUrl + "/organisations/:organisationId", null, {

  public getOrganisationDataListener() {
    return this.getOrganisationDataUpdated.asObservable();
  }

  public getOrganisationDataDocumentListener() {
    return this.getOrganisationDataDocumentUpdated.asObservable();
  }

  public getOrganisationDataVideoListener() {
    return this.getOrganisationDataVideoUpdated.asObservable();
  }

  public getOrganisationNavDataListener() {
    return this.getOrganisationNavDataUpdated.asObservable();
  }

  public getOrganisationSubDataListener() {
    return this.getOrganisationSubDataUpdated.asObservable();
  }

  public getOrganisationNewsDataListener() {
    return this.getOrganisationNewsDataUpdated.asObservable();
  }

  public getOrganisationOrgDataListener() {
    return this.getOrganisationOrgDataUpdated.asObservable();
  }

  public getOrganisationDataListenerDepartmentFiles() {
    return this.getOrganisationDataUpdatedDepartmentFiles.asObservable();
  }

  public getOrganisationLinksDataListener() {
    return this.getOrganisationLinksDataUpdated.asObservable();
  }

  public getOrganisationLinksDepartmentDataListener() {
    return this.getOrganisationLinksDepartmentDataUpdated.asObservable();
  }

  public getOrganisationAllDepartmentNamesDataListener() {
    return this.getOrganisationAllDepartmentNamesDataUpdated.asObservable();
  }

  public getCompanyInfoDataListener() {
    return this.getCompanyInfoDataUpdated.asObservable();
  }
}

